export default __webpack_public_path__ + "static/media/YE.9993b80d.svg";